const SUSPEND_STOPS = [
  { days: 7, label: "7 days" },
  { days: 14, label: "14 days" },
  { permanent: true as const, label: "Permanent" },
] as const;

export type SuspendStopIndex = 0 | 1 | 2;

export function isPermanentSuspendStop(index: SuspendStopIndex) {
  return index === 2;
}

export function suspendStopLabel(index: SuspendStopIndex) {
  return SUSPEND_STOPS[index].label;
}

export function suspendStopDays(index: SuspendStopIndex) {
  const stop = SUSPEND_STOPS[index];
  return "days" in stop ? stop.days : null;
}

export function ModerationSuspendPicker({
  value,
  onChange,
}: {
  value: SuspendStopIndex;
  onChange: (value: SuspendStopIndex) => void;
}) {
  const selected = SUSPEND_STOPS[value];
  const isPermanent = isPermanentSuspendStop(value);

  return (
    <div className="moderation-suspend-picker">
      <div
        className="segmented-options moderation-suspend-options"
        role="radiogroup"
        aria-label="Suspension duration"
      >
        {SUSPEND_STOPS.map((stop, index) => {
          const stopIsPermanent = index === 2;
          const isActive = index === value;
          return (
            <button
              key={stop.label}
              type="button"
              role="radio"
              aria-checked={isActive}
              className={[
                isActive ? "selected" : "",
                stopIsPermanent ? "is-permanent" : "",
              ].filter(Boolean).join(" ")}
              onClick={() => onChange(index as SuspendStopIndex)}
            >
              {stop.label}
            </button>
          );
        })}
      </div>

      <p className={`moderation-suspend-picker-note${isPermanent ? " moderation-suspend-picker-note--danger" : ""}`}>
        {isPermanent
          ? "Permanent suspension removes this member from matching until an admin lifts it. They can still sign in."
          : `Temporary suspension pauses matching access for ${selected.label}.`}
      </p>
    </div>
  );
}
